import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { recipesData } from '../data/recipes';
import './DishesSection.css';

const DishesSection = ({ title = "Dishes You Can Create", subtitle = "Explore authentic recipes curated for our artisanal blends", limit = 3 }) => {
  // Take the first 3 or specific count of recipes as default display
  const displayRecipes = recipesData.slice(0, limit);

  return (
    <section className="dishes-discovery-section">
      <div className="container">
        <div className="section-header text-center">
          <span className="accent-sub">Chef’s Corner</span>
          <h2 className="discovery-title">{title.split(' ').map((word, i) => i === title.split(' ').length - 1 ? <span key={i} className="gradient-text">{word}</span> : word + ' ')}</h2>
          <p>{subtitle}</p>
        </div>

        <div className="recipe-cards-grid">
          {displayRecipes.map((recipe, i) => (
            <motion.div
              key={recipe.id}
              className="dish-card-premium"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
              data-cursor
            >
              <Link to={`/recipe/${recipe.id}`} className="dish-card-link">
                <div className="dish-image">
                  <img src={recipe.img} alt={recipe.name} />
                  <div className="dish-overlay">
                    <span className="dish-time">{recipe.time}</span>
                  </div>
                </div>
                <div className="dish-info">
                  <span className="dish-cat">{recipe.category}</span>
                  <h3>{recipe.name}</h3>
                  <p>{recipe.description.substring(0, 80)}...</p>
                  <span className="view-recipe">View Full Recipe →</span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DishesSection;
